import type { ApiClient } from './client';

export const searchMethods = {
async searchVehicles(filters: any): Promise<any[]> {
      try {
        const queryParams = new URLSearchParams();

        Object.keys(filters).forEach(key => {
          if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
            queryParams.append(key, filters[key].toString());
          }
        });

        const response = await this.makeRequest<any[]>(`/vehicles_search.php?${queryParams.toString()}`);
        return response.data || [];
      } catch (error: any) {
        console.error('Failed to search vehicles:', error);
        throw new Error(error.message || 'Failed to search vehicles');
      }
    }
} satisfies ThisType<ApiClient>;
